import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Calendar, ArrowRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang } from "../contexts/LangContext";
import { api } from "../lib/api";
import { PageHeader } from "./Formats";

export default function Eventi() {
  const { t, lang } = useLang();
  const [events, setEvents] = React.useState([]);

  React.useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="eventi-page">
      <PageHeader
        eyebrow={t.events.eyebrow}
        title={t.events.title}
        subtitle={t.events.subtitle}
      />

      <section className="bg-[#0a0a0a] pb-32">
        <div className="container-x">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {events.map((ev, i) => (
              <Reveal key={ev.id} delay={(i % 2) * 100}>
                <article
                  className="premium-card group h-full flex flex-col"
                  data-testid={`event-card-${ev.id}`}
                >
                  <div className="relative aspect-[16/10] zoom-img">
                    <img src={ev.image_url} alt={ev.title_it} className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                    <div className="absolute top-5 left-5 flex gap-2">
                      <span className="badge-pill bg-black/60">
                        {lang === "it" ? ev.category_it : ev.category_en}
                      </span>
                    </div>
                  </div>
                  <div className="p-7 flex-1 flex flex-col">
                    <div className="flex items-center gap-5 text-xs font-display tracking-[0.22em] uppercase text-[color:var(--txt-muted)] mb-4">
                      {ev.year && (
                        <span className="flex items-center gap-2">
                          <Calendar className="w-3.5 h-3.5 text-[color:var(--gold)]" />
                          {ev.year}
                        </span>
                      )}
                      {ev.location && (
                        <span className="flex items-center gap-2">
                          <MapPin className="w-3.5 h-3.5 text-[color:var(--gold)]" />
                          {ev.location}
                        </span>
                      )}
                    </div>
                    <h3 className="h3 text-white">{lang === "it" ? ev.title_it : ev.title_en}</h3>
                    <p className="text-[color:var(--txt-secondary)] mt-3 leading-relaxed flex-1">
                      {lang === "it" ? ev.description_it : ev.description_en}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          <div className="mt-20 border border-white/10 p-10 lg:p-14">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
              <div className="lg:col-span-8">
                <div className="eyebrow mb-3">{t.cta.eyebrow}</div>
                <h2 className="h2 text-white">{t.cta.title}</h2>
                <p className="body-lg mt-4">{t.cta.body}</p>
              </div>
              <div className="lg:col-span-4 flex lg:justify-end">
                <Link to="/contatti" className="btn-primary" data-testid="eventi-cta">
                  {t.common.contactUs} <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
